import Cookie from 'universal-cookie'
import type { FeatureFlagCookieStore } from '@/types/FeatureFlagCookies.type'

/**
 * Gets the cookie store for feature flags.
 */
export function getCookieStore(
  cookies?: FeatureFlagCookieStore | string,
): FeatureFlagCookieStore | undefined {
  if (typeof cookies === 'string') {
    return new Cookie(cookies)
  }

  if (typeof document === 'undefined') {
    return cookies
  }

  return cookies || new Cookie(document.cookie)
}
